import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LAST_VISITED_PATH_KEY = 'last_visited_path';

/**
 * Цей компонент не рендерить нічого. 
 * Його єдине завдання - відстежувати зміни URL 
 * і зберігати останню відвідану сторінку в sessionStorage.
 */
export const LocationSaver = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    // Ми не хочемо зберігати сторінку авторизації або корінь
    if (path !== '/' && path !== '/auth') {
      sessionStorage.setItem(LAST_VISITED_PATH_KEY, path);
    }
  }, [location.pathname]);

  return null; // Невидимий компонент
};
